import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Form, Button, Alert } from "react-bootstrap";

import { createApplicantActionRequest } from "api/menu/hr/applicant-actions/actions";

class RejectionReasonModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rejectionReason: "",
            isSubmitting: false
        };
        
        // Expose submit method to parent
        if (props.onRef) {
            props.onRef(this);
        }
    }

    handleSubmit = (e) => {
        if (e) e.preventDefault();
        
        if (!this.state.rejectionReason.trim()) {
            return false;
        }

        this.setState({ isSubmitting: true });

        // Create the comment with "REJECTION REASON: " prefix
        const commentData = {
            applicantId: this.props.applicantId,
            action: "Comment",
            details: `REJECTION REASON: ${this.state.rejectionReason.trim()}`,
            userId: this.props.currentUserId
        };

        // Create the comment action
        this.props.createApplicantActionRequest(commentData, (success) => {
            if (success && this.props.onConfirmed) {
                // Call the callback with the rejection reason for status update
                this.props.onConfirmed(this.state.rejectionReason.trim());
            }
            this.setState({ isSubmitting: false });
        });
        
        return true;
    };

    handleReasonChange = (e) => {
        this.setState({ rejectionReason: e.target.value });
    };

    render() {
        const { rejectionReason, isSubmitting } = this.state;
        
        const isValid = rejectionReason.trim().length > 0 && rejectionReason.length <= 1000;

        return (
            <div>
                <Alert variant="warning" className="mb-3">
                    <strong>Rejection Reason Required</strong><br/>
                    You must provide a reason for rejecting this applicant. This will be recorded as a comment in the applicant's history.
                </Alert>

                <Form onSubmit={this.handleSubmit}>
                    <Form.Group>
                        <Form.Label>
                            Rejection Reason <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={rejectionReason}
                            onChange={this.handleReasonChange}
                            placeholder="Enter the reason for rejecting this applicant..."
                            maxLength={1000}
                            required
                            disabled={isSubmitting}
                            autoFocus
                        />
                        <Form.Text className="text-muted">
                            {rejectionReason.length}/1000 characters
                        </Form.Text>
                    </Form.Group>

                    {!isValid && rejectionReason.length > 0 && (
                        <Alert variant="warning" className="mb-3">
                            <small>Rejection reason is required and must be 1-1000 characters.</small>
                        </Alert>
                    )}

                    <div className="d-flex justify-content-end">
                        <Button 
                            variant="secondary" 
                            className="mr-2" 
                            onClick={this.props.onCancel}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </Button>
                        <Button 
                            type="submit" 
                            variant="danger"
                            disabled={!isValid || isSubmitting}
                        >
                            {isSubmitting ? "Rejecting..." : "Reject Applicant"}
                        </Button>
                    </div>
                </Form>
            </div>
        );
    }
}

RejectionReasonModal.propTypes = {
    applicantId: PropTypes.number.isRequired,
    currentUserId: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirmed: PropTypes.func.isRequired,
    createApplicantActionRequest: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    currentUserId: state.auth.user.id
});

const mapDispatchToProps = dispatch => ({
    createApplicantActionRequest: bindActionCreators(createApplicantActionRequest, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RejectionReasonModal);
